var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFocusedScalpDiagnosisIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e5l9u2qdpa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0a7.736 7.736 0 0 0-7.728 7.729v7.9c-.002.227.068.45.2.635v2.65A1.086 1.086 0 0 0 3.572 20h6.764a1.093 1.093 0 0 0 1.064-.864v-.057h.5c1.764 0 3.157 0 4.136-.715a4.586 4.586 0 0 0 1.357-1.928 1.093 1.093 0 0 0 .336-.793V7.729A7.736 7.736 0 0 0 10 0zM3.914 7.729A6.093 6.093 0 0 1 10 1.62a6.093 6.093 0 0 1 6.086 6.086v7.357H3.943L3.914 7.73zm11.129 9.285c-.536.407-1.736.4-3.136.393h-.55a1.543 1.543 0 0 0-1.428.922H4.122V16.7h11.242c-.09.13-.198.245-.321.343v-.029z",
    fill: "#6435C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e5l9u2qdpa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusedScalpDiagnosisIcon);
export default __webpack_public_path__ + "static/media/focusedScalpDiagnosisIcon.eb4dda5e.svg";
export { ForwardRef as ReactComponent };